import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.OnOff
 * The DEFA OnOff model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	zone: '/zone',
	onOff: '/onOff?attrs=',
};

const OnOff = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('unitId') + api.zone +
				this.get('zoneNumber') + api.onOff + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			onOff         : null,
			onOffError    : null
		}),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------


	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.onOff){
				this.parseAttribute('onOff', response.onOff, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			this.set(newModelAttributes);
		}
	},

	getAttributes: function() {
		return 'onOff';
	},
	
	toBackendJSON: function() {
		return {onOff :'ON' === this.get('onOff') };
	},
	
	_getDependentModels: function(){
		let self = this;
		let mode = channel.request('zoneHolders').get(self.get('unitId')).getZone(this.get('zoneNumber')).getModel('5').get('zoneMode');
		let dependentModels = [];
		if('thermostat' === mode){
			dependentModels.push(channel.request('zoneHolders').get(self.get('unitId')).getZone(this.get('zoneNumber')).getModel('3'));
		}else if('regulator'=== mode){
			dependentModels.push(channel.request('zoneHolders').get(self.get('unitId')).getZone(this.get('zoneNumber')).getModel('4'));
		}
		return dependentModels;
	},
	
	
} );

export default OnOff;
